import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { TextField, TextFieldSkeleton } from 'components/shared/TextField/TextField';
import { FC, useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  fileCode?: string;
}

export const FileCode: FC<OwnProps> = ({ fileCode }) => {
  const { isLoading } = useContext(AddonMainFormContext);

  return (
    <BlockOrientationFormGroup inputId="fileCode" label="addon.fileCode">
      {(!isLoading || fileCode) && <TextField id="fileCode" value={fileCode} isReadOnly />}
      {isLoading && !fileCode && <TextFieldSkeleton />}
    </BlockOrientationFormGroup>
  );
};

FileCode.displayName = 'FileCode';
